import { LeadCaptureProps } from "./types";

type OptionalPropertyOf<T extends object> = Exclude<
  {
    [K in keyof T]: T extends Record<K, T[K]> ? never : K;
  }[keyof T],
  undefined
>;

const defaultState: Pick<
  LeadCaptureProps["options"],
  OptionalPropertyOf<LeadCaptureProps["options"]>
> = {};

export default defaultState;
